import { hiddenFormParamTypes } from '../../types'
import { ReduxAction, reduxTypes } from '../types'

function merge(
  hiddenFormParams: hiddenFormParamTypes.HiddenFormParam[],
): ReduxAction<hiddenFormParamTypes.HiddenFormParam[]> {
  return {
    payload: [...hiddenFormParams],
    type: reduxTypes.HIDDEN_FORM_PARAMS_MERGE,
  }
}

export default {
  merge,
}
